import React from 'react';
import cn from 'classnames';
import { Title } from '@landing/ui';

import * as styles from './CountCard.module.scss';

export default function CountCard({ title, list, count, className }) {
  return (
    <div className={cn(className, styles.item)}>
      <div className={styles.count}>{count}</div>
      <Title tag="h3" className={styles.title}>
        {title}
      </Title>
      {list && (
        <ul className={styles.list}>
          {list.map(item => (
            <li key={item} className={styles.listItem}>
              <h4 className={styles.listItemTitle}>{item}</h4>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
